export default "__VITE_ASSET__BnGm8ZAw__"